import { useMemo } from "react";
import { SubServiceDetailPage } from "../../interfaces/SubServiceDetailPage";
import { Project } from "../../interfaces/project";

/**
 * Defines the projects for a SubServiceDetailPage
 * */
const projectsForServiceDetail: Record<SubServiceDetailPage, Project[]> = {
  [SubServiceDetailPage.AgencyMainz]: [
    Project.Vitis,
    Project.Bnbhotels,
    Project.Rheinelement,
    Project.EvolvingRegions,
    Project.Ksv,
  ],
  [SubServiceDetailPage.CorporateWebsite]: [
    Project.Vitis,
    Project.Bnbhotels,
    Project.Rheinelement,
    Project.EvolvingRegions,
    Project.Ksv,
  ],
  [SubServiceDetailPage.Backend]: [Project.DeineInsel, Project.Resolvio],
  [SubServiceDetailPage.BackendPython]: [Project.DeineInsel, Project.Resolvio],
  [SubServiceDetailPage.BackendNodeJs]: [Project.DeineInsel, Project.Resolvio],
  [SubServiceDetailPage.Deployment]: [
    Project.DeineInsel,
    Project.Resolvio,
    Project.Picwise,
  ],
  [SubServiceDetailPage.Docker]: [
    Project.DeineInsel,
    Project.Resolvio,
    Project.Picwise,
  ],
  [SubServiceDetailPage.Shop]: [],
  [SubServiceDetailPage.Shopify]: [],
  [SubServiceDetailPage.Frontend]: [
    Project.DeineInsel,
    Project.Resolvio,
    Project.Picwise,
  ],
};

/**
 * Get a map that defines the projects that are displayed for a SubServiceDetailPage
 * */
export const useProjectsForServiceDetail = (): Record<
  SubServiceDetailPage,
  Project[]
> => useMemo(() => projectsForServiceDetail, []);
